<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="MSDS 제개정" class="cardClassDetailForm revisionLayout" topClass="topcolor-orange" :isRevision="isRevision">
        <template slot="card-select">
          <!-- 개정이력 -->
          <c-select
            :editable="!isRevision"
            :comboItems="revs"
            type="custom"
            typetext="개정이력"
            itemText="revisionNum"
            itemValue="mdmChemMaterialMsdsId"
            label=""
            name="selectedId"
            v-model="selectedId"
            @input="rowClickRev"
          ></c-select>
        </template>
        <template slot="card-button">
          <q-btn-group outline >
            <!-- 개정 -->
            <c-btn
              v-show="editable && !isRevision"
              label="LBLREV"
              icon="restart_alt"
              @btnClicked="setRevision" />
            <!-- 개정취소 -->
            <c-btn
              v-show="editable && isRevision"
              label="LBLREVCANCEL"
              icon="restart_alt"
              @btnClicked="cancelRevision" />
            <c-btn
              v-show="editable && isRevision"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="chemData"
              mappingType="POST"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveInfo"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="row">
              <div class="col-1">
                <!-- 개정번호 -->
                <c-text
                  :required="editable && isRevision"
                  :editable="editable && isRevision"
                  label="LBLREVNO"
                  name="revisionNum"
                  v-model="chemData.revisionNum">
                </c-text>
              </div>
              <div class="col-2">
                <!-- 개정일시 -->
                <c-text
                  v-if="editable && !isRevision"
                  :editable="false"
                  label="LBLREVPERIOD"
                  name="msdsRegDtStr"
                  v-model="chemData.msdsRegDtStr">
                </c-text>
                <c-datepicker
                  v-else
                  required
                  :editable="editable"
                  label="개정일시"
                  name="msdsRegDtStr"
                  v-model="chemData.msdsRegDtStr"
                />
              </div>
              <div class="col-1">
                <!-- 개정자 -->
                <c-text
                  :editable="false"
                  label="LBLREVUSER"
                  name="msdsRegUserName"
                  v-model="chemData.msdsRegUserName">
                </c-text>
              </div>
              <div class="col-4">
                <!-- 개정사유 -->
                <c-text
                  :required="editable && isRevision"
                  :editable="editable && isRevision"
                  label="LBLREVREASON"
                  name="revisionContent"
                  v-model="chemData.revisionContent">
                </c-text>
              </div>
            </div>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="MSDS 파일" class="cardClassDetailForm">
        <template slot="card-detail">
          <div class="col-12">
            <c-upload
              :attachInfo="attachInfo"
              :editable="editable && revEditable"
              label="MSDS 파일">
            </c-upload>
          </div>
        </template>
      </c-card>
    </div>
    <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <c-card title="MSDS 업체용" class="cardClassDetailForm">
        <template slot="card-detail">
          <div class="col-12">
            <c-upload
              :attachInfo="attachInfo2"
              :editable="editable && revEditable"
              label="MSDS 업체용 첨부파일">
            </c-upload>
          </div>
        </template>
      </c-card>
    </div> -->
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'chem-msdsfile',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
      }),
    },
    chemData: {
      type: Object,
      default: () => ({
        plantCd: null,  // 사업장코드
        mdmChemMaterialId: '',  // 화학자재 일련번호
        materialCd: '',  // 자재코드
        mdmChemReviewId: '',  // 사전검토 일련번호
        deliveryVendorCd: '',  // 공급업체 코드
        // mfgVendorCd: '',  // (사용안함) 제조업체 코드
        propertiesStateCd: null,  // 성상-공통코드
        fugacity: '',  // 비산성(고체)
        boilPoint: '',  // 끊는점(액체,기체)
        meltingPoint: '',  // 녹는점
        moleWeight: '',  // 분자량
        usageCd: null,  // 용도-회사별 공통코드
        usageEtc: '',  // 용도 기타
        mixFlag: '',  // 물질구성(단일 N/혼합 Y)
        casNo: '',  // CAS No.
        // hsNo: '',  // (사용안함) HS번호
        // specificGravity: '',  // (사용안함) 비중
        // serialNo: '',  // (사용안함) 고유번호(유독물번호or고시번호)
        // keNo: '',  // (사용안함) KE 번호
        // storagePlace: '',  // (사용안함) 보관장소
        productCategoryCd: null,  // 제품구분
        keepFacilityFlag: 'N',  // 보관시설 유무
        maxKeepAmount: '',  // 최대보관량
        storageFacilityFlag: 'N',  // 저장시설 유무
        maxStorageAmount: '',  // 최대저장량
        manufacturingFacilitiesFlag: 'N',  // 제조 사용시설 여부
        nanoManufacturingFlag: 'N',  // 나노물질 제조 여부
        nanoIncomeFlag: 'N',  // 나노물질 수입 여부
        nanoNoneApplicableFlag: 'N',  // 나노물질 해당없음 여부
        nanoUnknownFlag: 'N',  // 나노물질 모름 여부
        inputDissolutionTank: '',  // 투입 용해조
        productManufClassCd: null,  // 제품제조구분 코드
        chemIngredientsCd: '',  // 구성성분 작성근거
        useFlag: 'Y',  // 사용여부
        licensingFlag: 'N',  // 인허가대상 물질 여부 Y/N
        dangerFlag: 'N',  // 위험물 여부Y/N
        psmFlag: 'N',  // PSM 대상 여부
        makeFlag: 'N',  // 제품분류(제조)
        impFlag: 'N',  // 제품분류(수입)
        buyFlag: 'N',  // 제품분류(구매)
        usingFlag: 'N',  // 제품분류(사용)
        expFlag: 'N',  // 제품분류(수출)
        salesFlag: 'N',  // 제품분류(판매)
        toxicPoisonFlag: 'N',  // 유해화학물질포함여부(유독물질)
        toxicPermitFlag: 'N',  // 유해화학물질포함여부(허가물질)
        toxicLimitFlag: 'N',  // 유해화학물질포함여부(제한물질)
        toxicProhibitFlag: 'N',  // 유해화학물질포함여부(금지물질)
        remarks: '',  // 비고
        regUserId: '',  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        mdmChemMaterialMsdsId: '',
        revisionNum: '',
        groupId: '',
        sysRevision: 1,
        revisionContent: '제정',
        msdsRegDtStr: '',
        msdsRegUserName: '',
        // specialCtype: '',  // (사용안함) 발암성 C-위험성평가용
        // specialRtype: '',  // (사용안함) 생식독성 R-위험성평가용
        // specialMtype: '',  // (사용안함) 생식세표변이원성 M-위험성평가용
        // rcode: '',  // (사용안함) 위험문구(R-phrase)-위험성평가용
        // hcode: '',  // (사용안함) 유해위험문구(H-code)-위험성평가용
        // cmrFlag: '',  // (사용안함) CMR물질여부-위험성평가용
        // boilingPoint: '',  // (사용안함) 끓는점-위험성평가용
        // hrCodeGrade: '',  // (사용안함) 위험문구/유해위험문구 등급-위험성평가용
        // maleficenceForm: '',  // (사용안함) 유해성 발생형태-위험성평가용
        // maleficenceValue: '',  // (사용안함) 유해성 측정값-위험성평가용
        // maleficenceGrade: '',  // (사용안함) 비산성 등급-위험성평가용
        // maleficenceType: '',  // (사용안함) 비산/휘발성 구분-위험성평가용
        // dayVolume: '',  // (사용안함) 하루취급량
        // dayVolumeUnit: '',  // (사용안함) 하루취급량 단위
        // ghsFlag: '',  // (사용안함) GHS 분류코드
      }),
    },
  },
  data() {
    return {
      revs: [],
      savedMdmChemMaterialMsdsId: '',
      editable: true,
      isSave: false,
      isRevision: false,
      detailUrl: '',
      revListUrl: '',
      revVersionUrl: '',
      saveUrl: '',
      selectedId: null,
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'CHEM_MSDS',
        taskKey: '',
        beforeTaskKey: '',
        isRev: false,
      },
      attachInfo2: {
        isSubmit: '',
        taskClassCd: 'CHEM_MSDS_VENDOR',
        taskKey: '',
        beforeTaskKey: '',
        isRev: false,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    revEditable() {
      return this.selectedId === this.savedMdmChemMaterialMsdsId
    }
  },  
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.detailUrl = selectConfig.mdm.mam.chem.msdsUnit.get.url;
      this.revListUrl = selectConfig.mdm.mam.chem.msdsUnit.rev.url;
      this.revVersionUrl = selectConfig.com.revision.getversion
      this.saveUrl = transactionConfig.mdm.mam.chem.msdsUnit.insert.url;

      this.$set(this.$data, 'selectedId', this.chemData.mdmChemMaterialMsdsId)
      this.$set(this.$data, 'savedMdmChemMaterialMsdsId', this.chemData.mdmChemMaterialMsdsId)
      this.$set(this.attachInfo, 'taskKey', this.chemData.mdmChemMaterialMsdsId)
      this.$set(this.attachInfo2, 'taskKey', this.chemData.mdmChemMaterialMsdsId)

      this.getRevList(this.chemData.groupId);
    },
    getDetail(id, check) {
      let _id = id ? id : this.chemData.mdmChemMaterialMsdsId
      this.$http.url = this.$format(this.detailUrl, _id);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.$_.extend(this.chemData, {
          mdmChemMaterialMsdsId: _result.data.mdmChemMaterialMsdsId,
          revisionNum: _result.data.revisionNum,
          groupId: _result.data.groupId,
          sysRevision: _result.data.sysRevision,
          revisionContent: _result.data.revisionContent,
          msdsRegDtStr: _result.data.msdsRegDtStr,
          msdsRegUserName: _result.data.msdsRegUserName,
        })

        if (check) {
          this.getRevList(_result.data.groupId);
        }
      },);
    },
    getRevList(_groupId) {
      this.$http.url = this.revListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        groupId: _groupId
      };
      this.$http.request((_result) => {
        this.revs = _result.data;
      },);
    },
    setRevision() {
      this.$http.url = this.revVersionUrl;
      this.$http.param = {
        revisionNum: this.chemData.revisionNum
      }
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.chemData.revisionNum = _result.data;
        this.chemData.regUserId = this.$store.getters.user.userId;
        this.chemData.revisionContent = '';
        this.chemData.regDtStr = '';
        this.chemData.regUserName = '';
        this.isRevision = true;
        /**
         * 첨부파일 셋팅
         */
        this.$set(this.attachInfo, 'taskKey', '')
        this.$set(this.attachInfo, 'beforeTaskKey', this.chemData.mdmChemMaterialMsdsId)
        this.$set(this.attachInfo, 'isRev', true)
        this.$set(this.attachInfo2, 'taskKey', '')
        this.$set(this.attachInfo2, 'beforeTaskKey', this.chemData.mdmChemMaterialMsdsId)
        this.$set(this.attachInfo2, 'isRev', true)
      });
    },
    cancelRevision() {
      this.isRevision = false;
      /**
       * 첨부파일 셋팅
       */
      this.$set(this.attachInfo, 'taskKey', this.chemData.mdmChemMaterialMsdsId)
      this.$set(this.attachInfo, 'beforeTaskKey', '')
      this.$set(this.attachInfo, 'isRev', false)
      this.$set(this.attachInfo2, 'taskKey', this.chemData.mdmChemMaterialMsdsId)
      this.$set(this.attachInfo2, 'beforeTaskKey', '')
      this.$set(this.attachInfo2, 'isRev', false)

      this.selectedId = this.chemData.mdmChemMaterialMsdsId;
      this.getDetail(this.selectedId, false)
    },
    rowClickRev(row) {
      if (row && row != this.chemData.mdmChemMaterialMsdsId) {
        this.selectedId = row;
        this.getDetail(this.selectedId, false)
        this.$set(this.attachInfo, 'taskKey', this.selectedId)
        this.$set(this.attachInfo2, 'taskKey', this.selectedId)
      }
    },
    saveInfo() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: '현재버전을 개정하여 저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.chemData.regUserId = this.$store.getters.user.userId;
          this.chemData.sysRevision = parseInt(this.chemData.sysRevision) + 1;

          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');

      /**
       * 첨부파일 셋팅
       */
      this.$set(this.attachInfo, 'taskKey', result.data)
      this.$set(this.attachInfo, 'isSubmit', uid())
      this.$set(this.attachInfo, 'beforeTaskKey', '')
      this.$set(this.attachInfo, 'isRev', false)
      this.$set(this.attachInfo2, 'taskKey', result.data)
      this.$set(this.attachInfo2, 'isSubmit', uid())
      this.$set(this.attachInfo2, 'beforeTaskKey', '')
      this.$set(this.attachInfo2, 'isRev', false)

      this.isRevision = false;
      this.selectedId = result.data;
      this.getDetail(result.data, true)
    },
  }
};
</script>